import * as React from "react";
import classnames from "classnames";
import { Util } from "@grandvisionhq/forms";
import { parseHtml } from "@grandvisionhq/lib-utils-html";
import { useIntl } from "@grandvisionhq/state";
import CheckboxField from "../CheckboxField/Consent/CheckboxField/CheckboxField.js";
/* empty css             */
const labelOptions = { parseHTML: false, parseLink: true, openLinksInNewTab: true };
const Consent = ({ className, errorMessage, consents, ...rest }) => {
  const { getFormattedLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("ul", { ...rest, className: classnames("consent", className) }, consents.map((consent) => /* @__PURE__ */ React.createElement("li", { key: consent.title, className: "consent__consent" }, /* @__PURE__ */ React.createElement(
    CheckboxField,
    {
      name: consent.value,
      label: /* @__PURE__ */ React.createElement(React.Fragment, null, parseHtml(getFormattedLabel(consent.title, labelOptions))),
      "aria-label": consent.ariaLabel,
      error: errorMessage,
      required: true,
      validations: [Util.validations.isRequired],
      "data-t": consent.value
    }
  ))));
};
export {
  Consent as default
};
//# sourceMappingURL=Consent.js.map
